import { get } from "../../utils/object-helpers";

$ {
const name = get(input, 'name', {});
const description = get(input, 'description', {});
const programTitle = get(input, 'programTitle', {});
const learnMoreText = get(input, 'learnMore', {});
const seeDetailsText = get(input, 'seeDetails.text', '');
const seeDetailsUrl = get(input, 'seeDetails.action.URL', '');
// removing follow charity until it's ready from service
// const followCharity = get(input, 'save', {})
}

<section class="str-charity about-layout--gutters">
    <div class="str-charity__intro">
        <div class="str-charity__programtitle">
            <str-charity-icon/>
            <str-textual-display ...programTitle />
        </div>
        <div class="str-charity__name">
            <str-textual-display ...name /> 
        </div>
        <div class="str-charity__description">
             <str-textual-display addLineBreaks=true class="str-charity-description__description" ...description/>
        </div>
        <div class="str-charity__container">
            <div class="str-charity__details">
                <ebay-button class="str-charity__details-btn black-btn" href=seeDetailsUrl priority="tertiary">
                    ${seeDetailsText}
                </ebay-button>
            </div>
            <!-- removing follow charity until it's ready from service -->
            <!-- <div class="str-charity__follow btn btn--tertiary">
                <follow-ebay class="fake-btn"
                    fakeLink=true blackButton=true noText=false
                    config=followCharity
                /> 
            </div> -->
        </div>
        <div class="str-charity__learnmore">      
            <str-textual-display class="str-charity__learnmore-link" ...learnMoreText />
            <ebay-arrow-right-12-icon/>
        </div>
    </div>
</section>
